import React, { useEffect } from 'react';

import Env from '../../config/env';
import Layout from '../../containers/Layout';
import { useDefaultGtm } from '../../hooks/gtm/default/useDefaultGtm';
import { minutesHumanize } from '../../utils/time.utils';
import { ImageTitle, SubTitle, Image } from './styles';
import IcPixExpired from '../../assets/images/pix-expired.svg';

const PixExpired = () => {
  const timeToPayment = minutesHumanize(Env.PIX_MIN_TO_EXPIRED);
  const { sendDataToGtm } = useDefaultGtm();

  useEffect(() => {
    sendDataToGtm({
      type: 'checkout',
      name: '/pagamento/infos-pagamento-error',
    });
  }, []);

  return (
    <Layout dark>
      <ImageTitle>
        <Image src={IcPixExpired} data-cy='pix-expired-icon'/>
        <SubTitle data-cy='pix-expired-text'>
          O tempo de {timeToPayment} para pagamento via código do Pix expirou.
        </SubTitle>
      </ImageTitle>
    </Layout>
  );
};

export default PixExpired;
